const formatDate = function (d) {
  return d.getMonth() + 1 + "/" + d.getDate() + "/" + d.getFullYear();
};

module.exports = formatDate;



//////////////////
// WEBPACK FOOTER
// ./utils/formatDate.js
// module id = 73
// module chunks = 0